import React from "react";
import { Link } from "react-router-dom";
// Import All Data
import OrganImg from "../../assets/img/sidebar/project_organizer.png"

// Import Recent Data
import Recent1 from "../../assets/img/sidebar/rec-donet-1.png"
import Recent2 from "../../assets/img/sidebar/rec-donet-2.png"
import Recent3 from "../../assets/img/sidebar/rec-donet-3.png"
import Recent4 from "../../assets/img/sidebar/rec-donet-4.png"
import Recent5 from "../../assets/img/sidebar/rec-donet-5.png"
// Import Recent Causes
import ReceCauses1 from "../../assets/img/sidebar/rec-cas-1.png"
import ReceCauses2 from "../../assets/img/sidebar/rec-cas-2.png"
import ReceCauses3 from "../../assets/img/sidebar/rec-cas-3.png"
import ReceCauses4 from "../../assets/img/sidebar/rec-cas-4.png"
// Import Social Icom
import facebook from "../../assets/img/icon/facebook.png"
import instagram from "../../assets/img/icon/instagram.png"
import twitter from "../../assets/img/icon/twitter.png"
import linkedin from "../../assets/img/icon/linkedin.png"
import tag from "../../assets/img/icon/tag.png"
import map from "../../assets/img/icon/map.png"
import cal from "../../assets/img/icon/cal.png"




const SideBar = () => {
    const RecentData =[
        {
           img:Recent1,
            heading:"Aisha M.",
           price:"Volunteer tutor",
           propsan:"Homework & integration",
           time:"This month"
        },
        {
            img:Recent2,
            heading:"Rafay S.",
            price:"Assistant coach",
            propsan:"Junior badminton",
            time:"This season"
         },
         {
            img:Recent3,
            heading:"Kiran T.",
            price:"Family donor",
            propsan:"Equipment fund",
            time:"Ongoing"
         },
         {
            img:Recent4,
            heading:"Noor F.",
            price:"Event helper",
            propsan:"Culture day",
            time:"Last event"
         },
         {
            img:Recent5,
            heading:"Ahmed Z.",
            price:"Board member",
            propsan:"PCF Sweden",
            time:"2026"
         },

    ]

    const CausesData =[
        {
           img:ReceCauses1,
           heading:"Badminton term times & ladder",
           time:"See news"
        },
        {
            img:ReceCauses2,
            heading:"Integration evening — schools",
            time:"Events page"
         },
         {
            img:ReceCauses3,
            heading:"Seasonal swim / cricket / football",
            time:"Newsletter"
         },
         {
            img:ReceCauses4,
            heading:"Independence Day celebration",
            time:"Save the date"
         },
      

    ]
  return (
    <>
      <div class="col-lg-4">
        <div class="sidebar_first">
          <div class="project_organizer_wrapper sidebar_boxed">
            <div class="project_organizer_img">
              <img src={OrganImg} alt="img" />
            </div>
            <div class="project_organizer_text">
              <h5>Program lead:</h5>
              <h3>Sana Malik</h3>
              <p>Education &amp; integration lead, PCF</p>
              <ul>
                <li>
                  <img src={tag} alt="icon" /> Category:
                  <span>Education &amp; integration</span>
                </li>
                <li>
                  <img src={map} alt="icon" /> Location:
                  <span>Sweden</span>
                </li>
                <li>
                  <img src={cal} alt="icon" /> Status:
                  <span>Ongoing</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="project_recentdonet_wrapper sidebar_boxed">
            <div class="sidebar_heading_main">
              <h3>Community supporters</h3>
            </div>
            {RecentData.map((data, index)=>(
                 <div class="recent_donet_item" key={index}>
                 <div class="recent_donet_img">
                   <Link to="/cause-details">
                     <img src={data.img} alt="img" />
                   </Link>
                 </div>
                 <div class="recent_donet_text">
                   <div class="sidebar_inner_heading">
                     <h4>
                       <Link to="/cause-details">{data.heading}</Link>
                     </h4>
                     <h5>{data.price}</h5>
                   </div>
                   <p>{data.propsan}</p>
                   <h6>{data.time}</h6>
                 </div>
               </div>
            ))}
          </div>
          <div class="recent_causes_wrapper sidebar_boxed">
            <div class="sidebar_heading_main">
              <h3>Related programs</h3>
            </div>
            {CausesData.map((data1, index1) =>(
                <div class="recent_donet_item" key={index1}>
                <div class="recent_donet_img">
                  <Link to="/cause-details">
                    <img src={data1.img} alt="img" />
                  </Link>
                </div>
                <div class="recent_donet_text">
                  <div class="sidebar_inner_heading">
                    <h4>
                      <Link to="/cause-details">
                        {data1.heading}
                      </Link>
                    </h4>
                  </div>
                  <h6>{data1.time}</h6>
                </div>
              </div>
            ))}
            
          
          </div>
          <div class="share_causes_wrapper sidebar_boxed">
            <div class="sidebar_heading_main">
              <h3>Share</h3>
            </div>
            <div class="social_icon_sidebar">
              <ul>
                <li>
                  <Link to="#">
                    <img src={facebook} alt="icon" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img src={instagram} alt="icon" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img src={twitter} alt="icon" />
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <img src={linkedin} alt="icon" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
